import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';



@Component({
  selector: 'sign-on',
  templateUrl: './sign-on.component.html'
})
export class SignOnComponent implements OnInit {
  currentLang: string;
  sidebarTitle: string;
  progressPercentage: string;
  applicant: boolean;
  preQualData: any;
  i: number = 0;
  constructor(private i18nService: I18nService, private utilService: UtilService, private router: Router, private _activatedRoute: ActivatedRoute) {
    this.utilService.isSidebarVisible.next(false);
  }

  ngOnInit(): void {
    this.preQualData = this.utilService.getSessionStorage();
    this.callFunction();
  }
  goToNext() {
    if (this.preQualData.is_existing_bankcustomers === 'Y' && this.preQualData.is_coapplicant_applied === 'Y' && this.preQualData.are_both_applicants_CIBC_customer === 'Y') {
      if (this.i == 1)
        this.callFunction();

      else if (this.i > 1) {
        this.router.navigate(['../personal-information'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
    }
    else if (this.preQualData.is_existing_bankcustomers === 'Y' && this.preQualData.is_coapplicant_applied === 'Y' && this.preQualData.are_both_applicants_CIBC_customer === 'N') {
      this.router.navigate(['../personal-information'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
    else if (this.preQualData.is_existing_bankcustomers === 'Y' && this.preQualData.is_coapplicant_applied === 'N' && this.preQualData.are_both_applicants_CIBC_customer === 'N') {
      this.router.navigate(['../personal-information'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
  }
  onCancel() {
    this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
  }

  callFunction() {
    if (this.i == 0) {
      this.i++;
    }
    else {
      if (this.i == 1) {
        this.i = 2
      }
    }
  }
}
